<script lang="ts" setup>
import EMethodos from '@/core/domain/emethodos/EMethodos.ts'
import { default as PCard } from 'primevue/card'
import { default as PChip } from 'primevue/chip'
import { default as PToggleButton } from 'primevue/togglebutton'
import { useEMethodosStore } from '@/presentation/stores/emethodos/emethodos.ts'
import { storeToRefs } from 'pinia'

const props = defineProps<{
  eMethodo: EMethodos
}>()

const { updateEMethodos, showSuccessToast, showErrorToast } = useEMethodosStore()
const { eMethodosStoreLoading, eMethodosStoreError } = storeToRefs(useEMethodosStore())

/**
 * Update the visibility of e-methodos
 */
async function changeVisibility() {
  await updateEMethodos(props.eMethodo.toInput())
  if (!eMethodosStoreError.value.hasError) {
    showSuccessToast(
      `"${props.eMethodo.title}" est maintenant ${props.eMethodo.visible ? 'visible' : 'invisible'} !`,
      ''
    )
  } else {
    showErrorToast(eMethodosStoreError.value.message, eMethodosStoreError.value.details)
  }
}
</script>

<template>
  <p-card
    class="fixed-card border-primary-100 bg-surface-0 h-full overflow-hidden rounded-xl border"
  >
    <template #header>
      <img alt="thumbnail" :src="eMethodo.thumbnail" />
    </template>
    <template #title>
      <p class="text-lg">{{ eMethodo.title }}</p>
    </template>
    <template #subtitle v-for="tag in eMethodo.tags" :key="`tags_${eMethodo.id}`">
      <p-chip class="text-xs">{{ tag }}</p-chip>
    </template>
    <template #footer>
      <p-toggle-button
        v-model="eMethodo.visible"
        onLabel="Visible"
        offLabel="Invisible"
        onIcon="pi pi-eye"
        offIcon="pi pi-eye-slash"
        class="w-36"
        aria-label="show or hide"
        :disabled="eMethodosStoreLoading.updateEMethodos"
        @change="changeVisibility"
      />
    </template>
  </p-card>
</template>

<style scoped>
.fixed-card :deep(.p-card-body) {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.fixed-card :deep(.p-card-content) {
  flex: 1;
}

.fixed-card :deep(.p-card-footer) {
  margin-top: auto;
}
</style>
